import React, { useEffect, useState } from 'react';

import { DealType, IDeal } from '~/src/dash/api/deals';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import {
  Col,
  Cols,
  IndependentSelect,
  spacing,
  Text,
  TooltipWithTranslation,
} from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { isPhiloPublisher, isSamsungNAPublisher, isTestPublisher } from '~/src/dash/utils/ui';

const defaultPriorityOptions: ISelectOption[] = [
  // { id: -1, label: 'None' }, // Deals Only
  // { id: 11, label: '0' }, // Samsung / Test Only
  { id: 10, label: 'Tier 1' },
  { id: 9, label: 'Tier 2' },
  { id: 8, label: 'Tier 3' },
  { id: 7, label: 'Tier 4' },
  { id: 6, label: 'Tier 5' },
  { id: 5, label: 'Tier 6' },
  { id: 4, label: 'Tier 7' },
  { id: 3, label: 'Tier 8' },
  { id: 2, label: 'Tier 9' },
  { id: 1, label: 'Tier 10' },
  // { id: 0, label: '11' },
];

export const generatePriorityList = (publisherID: string): ISelectOption[] => {
  const priorityOptions: ISelectOption[] = [{ id: -1, label: 'None' }];
  if (
    isSamsungNAPublisher(publisherID) ||
    isPhiloPublisher(publisherID) ||
    isTestPublisher(publisherID)
  ) {
    priorityOptions.push({ id: 11, label: 'Tier 0' });
  }
  priorityOptions.push(...defaultPriorityOptions);
  return priorityOptions;
};

interface IProps {
  deal: IDeal;
  handlePriorityChange: (tierSet: Set<number>) => void;
  isDisabled?: boolean;
  publisherID: string;
  selectedTier: number;
  shouldRefresh?: boolean;
}

export const DealPrioritySelect = ({
  deal,
  handlePriorityChange,
  isDisabled,
  publisherID,
  selectedTier,
  shouldRefresh,
}: IProps): React.ReactNode => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (shouldRefresh) {
      setKey((prevKey) => prevKey + 1);
    }
  }, [shouldRefresh]);

  return (
    <Cols style={{ alignItems: 'center' }}>
      <Col width={170}>
        <Text muted={isDisabled}>Deal Tier:</Text>
      </Col>

      <Col>
        <IndependentSelect
          handleApplySelect={handlePriorityChange}
          placeholder='Select Priority Tier'
          listLabel='Priority Tiers'
          singularLabel='Priority Tier'
          selectedLimit={1}
          disableSort
          isSelectionRequired
          options={generatePriorityList(publisherID)}
          selectedOptionIDs={new Set(selectedTier !== undefined ? [selectedTier] : [-1])}
          key={key}
          maxWidth={480}
          isDisabled={isDisabled}
        />
      </Col>

      {deal.DealType === DealType.ProgrammaticGuaranteed && (
        <Col displayFlex paddingLeft={spacing.small}>
          <TooltipWithTranslation tKey='DealTierTooltip'>
            <div>
              <IconV2 small name='info' color={publicaColors.mediumGray} />
            </div>
          </TooltipWithTranslation>
        </Col>
      )}
    </Cols>
  );
};
